import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';

export interface IconLabelProps {
  className?: string;
  color?: string;
  rightIcon?: React.ReactElement;
  leftIcon?: React.ReactElement;
  label: string;
  isLeft?: boolean;
  isRight?: boolean;
  gap?: string;
  alignItems?: string;
}
export const IconLabel: React.FC<IconLabelProps> = ({
  color,
  isLeft,
  isRight,
  label,
  leftIcon,
  rightIcon,
  alignItems = 'center',
  className = '',
  gap = '8',
  ...props
}) => {
  return (
    <Flex alignItems={alignItems} gap={gap}>
      {isLeft && leftIcon}
      <Box>
        <Text>{label}</Text>
      </Box>
      {isRight && rightIcon}
    </Flex>
  );
};

IconLabel.displayName = 'IconLabel';

export default IconLabel;
